import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-terms-and-conditions-modal',
  templateUrl: './terms-and-conditions-modal.component.html',
  styleUrls: ['./terms-and-conditions-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TermsAndConditionsModalComponent {
  constructor(
    private ActiveModal: NgbActiveModal,
    private ToastService: ToastService,
    private router: Router
  ) {}

  @Input() enforceConfirmation: boolean = true;

  close() {
    this.ActiveModal.dismiss({ isTermsAndConditionsConfirmed: false });
    if (this.enforceConfirmation) {
      this.router.navigate(['logout']);
    }
  }

  confirm() {
    this.ActiveModal.close({ isTermsAndConditionsConfirmed: true });
  }
}
